<template>
  <div class="radio-title">
    {{ label }}
    <v-radio-group
      column
      :value="value"
      :error-messages="getErrors(validator)"
      @change="$emit('input', $event)"
    >
      <v-radio
        v-for="item in items"
        :key="item"
        color="secondary"
        class="radio-description"
        :label="item"
        :value="item"
      />
    </v-radio-group>
  </div>
</template>

<script>


import { defaultMessages, getValidationErrors } from '@/utils'

export default {
  name: 'select-field',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemRender: {
      type: String,
      default: null,
    },
    itemSelect: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getErrors: function(field){
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style scoped>
.radio-title {
  font-size: 16px;
  line-height: 20px;
  color: #979797;
}
.radio-description {
  font-size: 14px;
  line-height: 18px;
}
</style>
